// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"78a20f58","169":"492ac003","238":"3540cae2","247":"21e29219","346":"8cf55401","453":"299ca079","639":"bfe3a935","640":"5408b804","762":"de9783b7"}[chunkId] + ".chunk.js";
};